<template>
    <client-page>
        <sub-visual sh="U the STAR" tabActive="재단소개" bg="/images/sub/visual/sv1.jpg"> </sub-visual>

        <section class="section">
            <v-container>
                <dept3-tab page="재단소개" tabActive="1"></dept3-tab>

                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">사업 운영 방향</h3>
                </div>

                <v-row>
                    <v-col cols="12" md="4" class="mb-10 mb-md-0">
                        <num-item num="01">
                            <h5 class="tit--sm font-weight-bold color-point mb-6 mb-lg-14">
                                아동 청소년 <br class="d-none d-lg-block" />
                                적극 지원 및 후원
                            </h5>
                            <p class="page-text">
                                아동·청소년 특히 취약계층을 대상으로 <br class="d-none d-lg-block" />
                                스포츠와 VR 체험·학습을 운영하며 <br class="d-none d-lg-block" />
                                건강한 성장과 사회 적응을 지원합니다. <br class="d-none d-lg-block" />
                                전문가와 지역사회가 함께하는 <br class="d-none d-lg-block" />
                                교육·나눔 활동으로 지속 가능한 <br class="d-none d-lg-block" />
                                스포츠 복지 모델을 실현합니다.
                            </p>
                        </num-item>
                    </v-col>
                    <v-col cols="12" md="4" class="mb-10 mb-md-0">
                        <num-item num="02">
                            <h5 class="tit--sm font-weight-bold color-point mb-6 mb-lg-14">
                                전문 체육인 재취업 및 <br class="d-none d-lg-block" />
                                양성 도모
                            </h5>
                            <p class="page-text">
                                다양한 종목의 은퇴 선수 출신 전문 <br class="d-none d-lg-block" />
                                스포츠 지도자를 배양하여 각종 스포츠 <br class="d-none d-lg-block" />
                                봉사활동 및 스포츠 지도자로서 새로운 <br class="d-none d-lg-block" />
                                도전을 할 수 있도록 적극 지원 및 <br class="d-none d-lg-block" />
                                후원한다.
                            </p>
                        </num-item>
                    </v-col>
                    <v-col cols="12" md="4">
                        <num-item num="03">
                            <h5 class="tit--sm font-weight-bold color-point mb-6 mb-lg-14">
                                국내외 스포츠 생활화 및 <br class="d-none d-lg-block" />
                                생활 스포츠 문화 주도
                            </h5>
                            <p class="page-text">
                                다양한 그룹, 종목별 체육 활동을 통해 <br class="d-none d-lg-block" />
                                공정한 참여의 기회를 마련하고, <br class="d-none d-lg-block" />
                                국내외 다양한 스포츠 교류를 통해 <br class="d-none d-lg-block" />
                                스포츠 대중화 및 K-스포츠 문화의 위상을 높인다.
                            </p>
                        </num-item>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="section bg-image" style="background-image: url(/images/sub/about/business/s2-bg.jpg)">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold color-white">사업 내용</h3>
                </div>

                <business-item v-for="(item, index) in items" :key="index" :class="{ 'mt-24': index !== 0 }" :num="(index + 1).toString().padStart(2, '0')" :tit="item.title">
                    <p v-for="(item, index) in item.items" :key="index" class="page-text dot-text" :class="{ 'mt-2 mt-lg-8': index !== 0 }">· {{ item }}</p>
                </business-item>
            </v-container>
        </section>

        <section class="section">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">연혁</h3>
                </div>

                <sub-history />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import Dept3Tab from "@/components/client/ko/sub/dept3-tab.vue";
import NumItem from "@/components/client/ko/sub/sub-num-item.vue";
import BusinessItem from "@/components/client/ko/sub/sub-business-item.vue";
import SubHistory from "@/components/client/ko/sub/sub-history.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        Dept3Tab,
        NumItem,
        BusinessItem,
        SubHistory,
    },
    data() {
        return {
            items: [
                {
                    title: "차상위계층의 스포츠 활동 참여 확대 지원",
                    items: [
                        "스포츠활동이 필요한 차상위(취약, 다문화, 한부모, 저소득, 탈북민 등) 계층을 대상으로 실질적인 체육활동 지원 방안 강구",
                        //
                    ],
                },
                {
                    title: "국내 프로 선수 출신의 전문교사 양성 및 선수 발굴",
                    items: [
                        "현직(전직) 프로 선수 경력 7년차 이상 또는 전문 스포츠 지도자 자격증을 겸비한 전문 교사 양성",
                        "현역 프로 스포츠 경력자의 경험과 인성을 키우는 교육을 통한 선수 발굴",
                        //
                    ],
                },
                {
                    title: "국내 프로 스포츠 유망 선수 양성 및 지원 (에이전트 및 매니지먼트)",
                    items: [
                        "스포츠에서 유망주가 될 수 있는 기회제공",
                        "취미에서 시작해 프로 스포츠 선수로 성장 기회 제공",
                        //
                    ],
                },
                {
                    title: "국내 스포츠 인재의 국제대회 참가 및 국내외 전지훈련 지원",
                    items: [
                        "국제 대회 설립을 목표로 대회 전지훈련 상시화",
                        "각종 국내 대회 및 국제 대회 지역 유치 토대 마련",
                        "지역 스포츠 경제활동 극대화 및 한류관광 목표로 대회 개최",
                        //
                    ],
                },
                {
                    title: "국외 선수 초청 및 국제 스포츠 교류를 통한 K-스포츠 위상 강화",
                    items: [
                        "국내 지역대회 개최 시 국외 선수 참가 유치 (지역경제 활성화 방안 마련)",
                        "세계 청소년들과 함께 할 수 있는 스포츠 대회 유치",
                        "겨울 스포츠가 없는 국가의 단체 초청을 통한 참여하는 스포츠 마련",
                        "스포츠 문화 전파 및 새로운 K-스포츠 문화 주도",
                        //
                    ],
                },
                {
                    title: "국내외 친환경 체육시설 설치 지원 사업",
                    items: [
                        "친환경 체육시설에 맞춤형 체육활동 프로그램 및 VR 스포츠 체험·학습 프로그램 개발",
                        "기존의 놀이터 및 체육시설을 친환경 + 디지털 융합형 체육공간으로 전환 설계 및 지원",
                        "스포츠 콘텐츠 개발 및 VR 기반 체육교육 콘텐츠 보급",
                        "체육시설 및 VR 스포츠룸의 개발, 설치, 운영, 관리",
                        //
                    ],
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
</style>